import { FC } from 'react';

import clsx from 'clsx';
import { Search, X } from 'lucide-react';

import IconButton from '@mui/material/IconButton';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import css from './SearchTextField.module.css';

interface SearchTextFieldProps {
  onClear?: VoidFunction;
}

export const SearchTextField: FC<SearchTextFieldProps & TextFieldProps> = ({
  className,
  onClear,
  slotProps,
  size = 'small',
  ...props
}) => (
  <TextField
    {...props}
    size={size}
    className={clsx(css.searchTextField, className)}
    slotProps={{
      ...slotProps,
      input: {
        startAdornment: <Search width={22} opacity={0.6} />,
        endAdornment: onClear && (
          <IconButton type="button" onClick={onClear}>
            <X width={16} height={16} />
          </IconButton>
        ),
      },
    }}
  />
);
